import script from "./AdminUserDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUserDetail.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/sites/AdminUserDetail.css?vue&type=style&index=0&id=f1365836&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1365836"]])

export default __exports__